import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { formatDateDDMMYYYY } from "../../../Utils/dateUtils";

export default function RescheduleAppointmentModal({
    open,
    onClose,
    onSubmit,
    appointment,
}) {
    const [newDate, setNewDate] = useState("");
    const [newTime, setNewTime] = useState("");
    const [remarks, setRemarks] = useState("");

    useEffect(() => {
        if (!open) return;

        setNewDate("");
        setNewTime("");
        setRemarks("");
    }, [open]);

    const handleSubmit = () => {
        if (!newDate || !newTime) return;

        onSubmit?.({
            appointment,
            newDate,
            newTime,
            remarks,
        });
    };

    const handleClose = () => {
        setNewDate("");
        setNewTime("");
        setRemarks("");
        onClose?.();
    };

    return (
        <>
            <Modal
                title={null}
                open={open}
                onCancel={handleClose}
                footer={null}
                centered
                width={620}
                className="reschedule-appointment-modal"
            >
                <div className="reschedule-modal-header">
                    <div className="reschedule-modal-icon">
                        <i className="bi bi-calendar2-week text-white"></i>
                    </div>

                    <div>
                        <h3>Reschedule Appointment</h3>
                        <p>Choose a new date, time slot, and add remarks</p>
                    </div>
                </div>

                <div className="reschedule-modal-body">
                    <div className="row g-3">
                        <div className="col-12">

                            <div
                                className="d-flex align-items-center justify-content-between rounded-4 p-3"
                                style={{
                                    background:
                                        "linear-gradient(135deg,#eff6ff,#ffffff)",
                                    border: "1px solid #bfdbfe",
                                }}
                            >
                                <div className="d-flex align-items-center gap-3">
                                    <div
                                        className="d-flex align-items-center justify-content-center"
                                        style={{
                                            width: "54px",
                                            height: "54px",
                                            borderRadius: "16px",
                                            background:
                                                "linear-gradient(135deg,#2563eb,#3b82f6)",
                                        }}
                                    >
                                        <i className="bi bi-calendar-event text-white fs-4"></i>
                                    </div>
                                    <div>
                                        <p className="text-muted small mb-1 fw-semibold">
                                            Current Appointment Date
                                        </p>
                                        <h5 className="fw-bold mb-0 text-dark">
                                            {formatDateDDMMYYYY(
                                                appointment?.AppointmentDate
                                            )}
                                        </h5>
                                    </div>
                                </div>
                                <span
                                    className="badge rounded-pill px-3 py-2"
                                    style={{
                                        background: "#dbeafe",
                                        color: "#1d4ed8",
                                        fontSize: "13px",
                                    }}
                                >
                                    Existing Schedule
                                </span>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label fw-bold text-muted mb-2">
                                New Date <span className="text-danger">*</span>
                            </label>

                            <div className="input-icon-wrap">
                                <i className="bi bi-calendar3"></i>
                                <input
                                    type="date"
                                    className="form-control form-control-lg"
                                    value={newDate}
                                    onChange={(e) => setNewDate(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <label className="form-label fw-bold text-muted mb-2">
                                New Time <span className="text-danger">*</span>
                            </label>

                            <div className="input-icon-wrap">
                                <i className="bi bi-clock-history"></i>
                                <input
                                    type="time"
                                    className="form-control form-control-lg"
                                    value={newTime}
                                    onChange={(e) => setNewTime(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="col-12">
                            <label className="form-label fw-bold text-muted mb-2">
                                Remarks
                            </label>

                            <textarea
                                rows="4"
                                className="form-control rounded-4"
                                placeholder="Enter reason for reschedule"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                            />
                        </div>
                    </div>
                </div>

                <div className="reschedule-modal-footer">
                    <button
                        type="button"
                        className="btn btn-light fw-bold px-4"
                        onClick={handleClose}
                    >
                        <i className="bi bi-x-circle me-2"></i>
                        Close
                    </button>

                    <button
                        type="button"
                        className="btn btn-primary fw-bold px-4"
                        onClick={handleSubmit}
                        disabled={!newDate || !newTime}
                    >
                        <i className="bi bi-calendar2-check me-2"></i>
                        Reschedule
                    </button>
                </div>
            </Modal>

            <style>
                {`
                    .reschedule-appointment-modal .ant-modal-content {
                        border-radius: 20px;
                        overflow: hidden;
                        padding: 0;
                        }

                        .reschedule-modal-header {
                        padding: 24px;
                        background: linear-gradient(135deg, #f59e0b, #2563eb);
                        color: #fff;
                        display: flex;
                        align-items: center;
                        gap: 16px;
                        }

                        .reschedule-modal-icon {
                        width: 54px;
                        height: 54px;
                        border-radius: 50%;
                        background: rgba(255, 255, 255, 0.2);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 26px;
                        }

                        .reschedule-modal-header h3 {
                        margin: 0;
                        font-size: 22px;
                        font-weight: 900;
                        color: #fff;
                        }

                        .reschedule-modal-header p {
                        margin: 4px 0 0;
                        color: rgba(255, 255, 255, 0.78);
                        font-weight: 600;
                        }

                        .reschedule-modal-body {
                        padding: 24px;
                        background: #f8fafc;
                        }

                        .reschedule-modal-footer {
                        padding: 16px 24px;
                        background: #fff;
                        border-top: 1px solid #eef2f7;
                        display: flex;
                        justify-content: flex-end;
                        gap: 10px;
                        }

                        .input-icon-wrap {
                        position: relative;
                        }

                        .input-icon-wrap > i {
                        position: absolute;
                        left: 14px;
                        top: 50%;
                        transform: translateY(-50%);
                        color: #2563eb;
                        font-size: 18px;
                        z-index: 2;
                        }

                        .input-icon-wrap .form-control {
                        padding-left: 44px;
                        border-radius: 14px;
                        border-color: #e5e7eb;
                        font-size: 14px;
                        font-weight: 700;
                        min-height: 46px;
                        }
                `}
            </style>
        </>
    );
}